import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import TRANSLATIONS, { translateBrand, translateCity, translateType } from "../lib/translations";

const STORAGE_KEY = "shams_lang";
const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState("en");

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "ar" || stored === "en") setLangState(stored);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const setLang = useCallback((l) => {
    if (l !== "en" && l !== "ar") return;
    localStorage.setItem(STORAGE_KEY, l);
    setLangState(l);
  }, []);

  const t = useCallback(
    (key, fallback) => {
      const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;
      return dict[key] || TRANSLATIONS.en[key] || fallback || key;
    },
    [lang]
  );

  const tBrand = useCallback((value) => translateBrand(lang, value), [lang]);
  const tCity = useCallback((value) => translateCity(lang, value), [lang]);
  const tType = useCallback((value) => translateType(lang, value), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tBrand, tCity, tType, isRTL: lang === "ar" }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
